import { render, staticRenderFns } from "./datatable.vue?vue&type=template&id=b2998822"
import script from "./datatable.vue?vue&type=script&lang=ts"
export * from "./datatable.vue?vue&type=script&lang=ts"
import style0 from "./datatable.vue?vue&type=style&index=0&id=b2998822&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports